import { ReplayJournalEntry } from '@/components/admin/reglages/replay-journal-entry';
import type { ReplaySettingsChange } from '@matter_extractor/shared';

/**
 * « Ce qui a déjà bougé » (docs/specs/rejeu.md §10.3): the journal of the
 * saves, on the screen that writes it - displayed, not merely stored.
 *
 * The same section, the same title and the same list of sentences as the
 * journal of the seats of Réglages > Modèles. The server answers newest first
 * and the screen keeps that order; the seed line is the last one, and it is
 * always there - the row exists as soon as the replay is open - so an empty
 * list is not a state of the screen but of a read that has not landed, which the
 * page words apart.
 *
 * The closing sentence says the two things the planche does: that on a server
 * where the replay is closed the tab does not exist, and that a refresh of the
 * dev model puts the starting texts back and says so here.
 */

export interface ReplayJournalProps {
  readonly changes: readonly ReplaySettingsChange[];
}

export function ReplayJournal({ changes }: ReplayJournalProps) {
  return (
    <section
      aria-labelledby="rejeu-journal-titre"
      data-testid="rejeu-journal"
      className="space-y-2.5"
    >
      <h3 id="rejeu-journal-titre" className="font-semibold text-bleu-nuit text-lg">
        Ce qui a déjà bougé
      </h3>
      {changes.length === 0 ? (
        <p data-testid="rejeu-journal-vide" className="text-gray-600 text-sm">
          Aucun enregistrement n’est inscrit au journal.
        </p>
      ) : (
        <ul className="m-0 flex list-none flex-col gap-2 p-0">
          {changes.map((change) => (
            <ReplayJournalEntry key={change.id} change={change} />
          ))}
        </ul>
      )}
      <p className="text-gray-500 text-xs">
        Sur un serveur où le rejeu est fermé (la production), cet onglet n’existe pas. Un
        rafraîchissement du modèle du dev remet les textes de départ, et le journal le dit.
      </p>
    </section>
  );
}
